import EducationTeacherForm from './EducationTeacherForm';

export default EducationTeacherForm;
